<!--
树组件，配置方法参考 /pos/center.vue
需要传入的参数有
title, keyName, filterKey, update
-->
<!--suppress JSXNamespaceValidation, HtmlUnknownAttribute -->
<template>
  <div class="-the-tree">
    <!--suppress JSUnresolvedVariable -->
    <el-tree ref="tree" default-expand-all
             :data="tree"
             v-loading="treeLoading"
             node-key="id"
             :expand-on-click-node="false"
             :filter-node-method="filterNode"
             :render-content="renderContent"
             :load="loadNode"
             @node-collapse="nodeCollapse"
             @node-click="handleNodeClick"
    />
  </div>
</template>

<script>
  export default {
    name: 's-tree',
    props: {
      netSelect: {
        type: Boolean,
        default: false
      },
      filterKey: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: '标题'
      },
      keyName: {
        type: String,
        default: '键名'
      },
      showPopBox: {
        type: Boolean,
        default: true
      },
      maxDepth: {
        type: Number,
        default: 4
      },
      options: {
        type: Object,
        default () {
          return {
            1: [],
            2: ['add'],
            3: ['add', 'patch', 'delete'],
            4: ['patch', 'delete']
          }
        }
      },
      update: {
        type: Object,
        default () {
          return {
            render: () => [],
          }
        }
      }
    },
    watch: {
      'filterKey' (val) {
        this.tree = []
        this.treeData = []
        console.log(val)
        this.render(0, val)
        // this.$refs.tree.filter(val)
      }
    },
    data () {
      return {
        tree: [],
        showDev: false,
        treeData: [],
        treeFromServer: [],
        detailForm: {
          title: '添加组织',
          show: false,
          then: () => {
          },
          type: ''
        },
        treeLoading: false
      }
    },
    created () {
      this.render(0)
    },
    methods: {
      filterNode (value, data) {
        if (!value) return true
        return data._label.indexOf(value) !== -1
      },
      render (code, searchKey) {
        if (code !== null) {
          this.treeLoading = true
          this.update.render(code, searchKey || '')
            .then(list => {
              let newArr = []
              for (let i = 0; i < this.treeData.length; i++) {
                if (this.treeData[i].parentCode !== code) {
                  newArr.push(this.treeData[i])
                }
              }
              this.treeData = newArr
              this.treeData.push.apply(this.treeData, list)
              // let maxParentID = 0
              // for (let j = 0; j < this.treeData.length; j++) {
              //   if (this.treeData[j].parentId > maxParentID) {
              //     maxParentID = this.treeData[j].parentId
              //   }
              // }
              // for (let k = 0; k < this.treeData.length; k++) {
              //   if (this.treeData[k].parentId === maxParentID && this.treeData[k].id) {
              //     let weakData = {
              //       id: '',
              //       level: this.treeData[k].level + 1,
              //       label: '',
              //       _label: '',
              //       name: '',
              //       parentId: this.treeData[k].id
              //     }
              //     newArr.push(weakData)
              //   }
              // }
              // this.treeData = newArr
              // setTimeout(() => {
              this.convertData()
              this.treeLoading = false
              if (list.length === 1 && list[0].parentCode == 0) {
                this.render(list[0].code, searchKey)
              }
              // })
            })
        }
      },

      convertData () {
        /**
         * 组装节点
         * @function
         * @param nodes
         */
        const packNode = (nodes) => {
          const getNodes = nodeId =>
            this.treeData.filter(n => n.parentCode === nodeId)

          nodes.forEach(node => {
            const children = getNodes(node.code)
            node.children = children
            if (children.length > 0) {
              packNode(children)
            }
          })
        }
        /**
         * 格式化原始数据
         */
        this.treeData
          .forEach(it => {
            it.edidable = false
            it.label = it._label
          })

        /**
         * 生成顶层节点
         */
        const tree = this.treeData.filter(tree => tree.parentCode == 0)
        /**
         * 开始组装节点
         */
        packNode(tree)

        this.tree = tree
      },
      copyObj (obj) {
        var newobj = {}
        for (var attr in obj) {
          newobj[attr] = obj[attr]
        }
        return newobj
      },
      nodeCollapse (data, node, $event) {
        data.children = []
        node.childNodes = []
        for (let y = 0; y < this.treeData.length; y++) {
          if (this.treeData[y].parentId === data.id) {
            this.treeData.splice(y, 1, [])
          }
        }
        this.render(data.parentCode)
      },
      handleNodeClick ($event) {
        this.render($event.code)
        this.$emit('selected', $event)
      },
      renderContent (h, { node, data, store }) {
        return (
          <span class="custom-tree-node">
            <span class="left" title={data._label}>{data._label}</span>
          </span>)
      },
      loadNode (node, resolve) {
      }
    }
  }
</script>

<style scoped>
  .el-tree{
    height: 700px!important;
    overflow-y: auto;
  }
</style>

<style lang="less" scoped>
  .el-tree-node > .el-tree-node__children {
    overflow: visible;
  }

  .-the-tree {
    overflow: hidden;
    .item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
    .el-icon-damai-zuzhijiagou, .el-icon-damai-biaoshilei_menjin, .el-icon-damai-renlianshibie{
      font-size: 14px;
      float: left;
      line-height: 25px;
      margin-right: 3px;
    }
    .left {
      display: block;
      min-width: 100px;
      float: left;
      line-height: 25px;
      max-width: 160px;
      overflow: hidden;
      text-align: left;
      text-overflow: ellipsis;
      white-space: nowrap;
      user-select: none;
    }
    .icon-more {
      display: block;
      font-size: 12px;
      color: #999999;
      position: relative;
      padding: 4px;
      overflow: visible;
      margin-right: 60px;
      .pop-box {
        display: none;
        background-color: #fff;
        width: 48px;
        position: absolute;
        top: 10px;
        left: 20px;
        user-select: none;
        z-index: 2018;
      }
      .operate {
        display: none;
        font-size: 12px;
        color: #999999;
        padding: 5px;
        margin-top: -1px;
        border: 1px solid #999999;
      }
      .operate:hover {
        color: #1362FF;
        border: 1px solid #1362FF;
      }
      &.show .pop-box {
        display: block !important;
        .operate {
          display: block !important;
        }
      }
    }
  }
</style>

<style lang="less">
  label {
    margin-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/s-tree.vue